import React from 'react';
export const KeyboardShortcutContext = React.createContext({
    combos: [],
    setCombos: ()=>{}
});